<template>
  <div>
    <Header />
    <div class="content">
      <div class="side-nav">
        <Sidebar :item="item" />
      </div>
      <div class="main-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import * as types from "../../../store/constant";
//import Search from "../../partials/search";
export default {
  name: "wallet",
  components: {
    Header,
    Sidebar,
  },
  data() {
    return {
      item: "wallet",
      headerDropDown: false,
    };
  },
  metaInfo: {
    title: "HR Desk Wallet - Simplified Employee Compensation Management",
    meta: [
      {
        name: "description",
        content:
          "Manage employee compensation effortlessly with HR Desk Wallet. Track payments, handle reimbursements, track wallet balance and view accurate next payroll run amount.",
      },
      { property: "og:title", content: "HR Desk Wallet - Simplified Employee Compensation Management" },
      {
        property: "og:description",
        content:
          "Manage employee compensation effortlessly with HR Desk Wallet. Track payments, handle reimbursements, track wallet balance and view accurate next payroll run amount.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://app.hrdesk.africa/wallet" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "HR Desk Wallet - Simplified Employee Compensation ManagementWallet - hrdesk" },
      {
        name: "twitter:description",
        content:
          "Manage employee compensation effortlessly with HR Desk Wallet. Track payments, handle reimbursements, track wallet balance and view accurate next payroll run amount.",
      },
      { name: "twitter:image:alt", content: "Wallet at hrdesk" },
      { name: 'keywords', content: 'HR wallet, employee compensation, balance tracking, wallet funding tracking, reimbursement management, HR payment solutions' },
    ],
  },
  methods: {
    dropDown() {
      if (this.headerDropDown) {
        this.headerDropDown = false;
      } else {
        this.headerDropDown = true;
      }
    },
    logOut() {
      this.$store
        .dispatch(types.AUTH_LOGOUT)
        .then(() => {
          this.$router.push("/login");
        })
        .catch();
    },
  },
  created() {
    let user = this.$store.getters.currentAuthUser;

    this.userName = user.firstname + " " + user.lastname;
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

  .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    padding-top: 4rem;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .main-content {
    margin-top: 4rem;
    background: #fbfafa;
    margin-left: 200px;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .content {
      flex-direction: column;
      padding: 0;
      
    }
  }
}
</style>
